<template>
  <div class="enroll-review">
    <el-card class="review-card">
      <template #header>
        <div class="card-header">
          <div class="header-title">
            <h3>自主招生审核管理</h3>
            <p>按状态筛选并快速执行审核操作</p>
          </div>
          <div class="stats">
            <el-tag v-for="item in stats" :key="item.status" :type="item.status === '不通过' ? 'danger' : 'info'" effect="plain">
              {{ item.status }}：{{ item.count }}
            </el-tag>
          </div>
        </div>
      </template>

      <el-form :model="filters" inline class="filter-bar">
        <el-form-item label="状态">
          <el-select v-model="filters.status" style="width: 180px">
            <el-option v-for="item in statusOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="filters.name" clearable />
        </el-form-item>
        <el-form-item label="初中学校">
          <el-input v-model="filters.school" clearable />
        </el-form-item>
        <el-form-item label="身份证件号">
          <el-input v-model="filters.id_card" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadStudents">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
          <el-button type="success" plain :loading="exporting" @click="exportFilteredStudents">
            导出筛选结果
          </el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="students" stripe class="review-table">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="姓名" min-width="120" />
        <el-table-column prop="gender" label="性别" width="90" />
        <el-table-column prop="school" label="初中学校" min-width="220" />
        <el-table-column prop="phone" label="联系电话" min-width="140" />
        <el-table-column label="审核状态" width="120">
          <template #default="{ row }">
            <el-tag :type="statusTagType(row.review_status)">
              {{ row.review_status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="已提交" width="100">
          <template #default="{ row }">
            <el-tag :type="row.application_submitted ? 'success' : 'warning'">
              {{ row.application_submitted ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="420" fixed="right">
          <template #default="{ row }">
            <div class="action-wrap">
              <el-button size="small" @click="openDetail(row.id)">详情</el-button>
              <el-button size="small" type="success" @click="review(row.id, '初审通过')">初审通过</el-button>
              <el-button size="small" type="primary" @click="review(row.id, '复审通过')">复审通过</el-button>
              <el-button size="small" type="warning" @click="review(row.id, '最终通过')">最终通过</el-button>
              <el-button size="small" type="danger" @click="review(row.id, '不通过')">不通过</el-button>
              <el-button size="small" @click="resetPassword(row.id)">重置密码</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog v-model="detailVisible" title="报名详情" width="74%">
      <template v-if="detail">
        <el-descriptions border :column="2">
          <el-descriptions-item label="姓名">{{ detail.name }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ detail.gender || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detail.phone }}</el-descriptions-item>
          <el-descriptions-item label="身份证件号">{{ detail.id_card }}</el-descriptions-item>
          <el-descriptions-item label="初中学校">{{ detail.school || '-' }}</el-descriptions-item>
          <el-descriptions-item label="户籍地址">{{ detail.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="statusTagType(detail.review_status)">
              {{ detail.review_status }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>

        <el-divider content-position="left">家长信息</el-divider>
        <el-descriptions border :column="2">
          <el-descriptions-item label="父亲">{{ detail.father_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="母亲">{{ detail.mother_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="父亲学历">{{ detail.father_edu || '-' }}</el-descriptions-item>
          <el-descriptions-item label="母亲学历">{{ detail.mother_edu || '-' }}</el-descriptions-item>
          <el-descriptions-item label="父亲电话">{{ detail.father_phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="母亲电话">{{ detail.mother_phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="父亲工作单位">{{ detail.father_work || '-' }}</el-descriptions-item>
          <el-descriptions-item label="母亲工作单位">{{ detail.mother_work || '-' }}</el-descriptions-item>
        </el-descriptions>

        <el-divider content-position="left">成绩</el-divider>
        <el-table :data="detail.grades || []" border>
          <el-table-column prop="stage" label="考试阶段" />
          <el-table-column prop="chinese" label="语文" />
          <el-table-column prop="math" label="数学" />
          <el-table-column prop="english" label="外语" />
          <el-table-column prop="physics" label="物理" />
          <el-table-column prop="chemistry" label="化学" />
          <el-table-column prop="total" label="总分" />
        </el-table>

        <el-divider content-position="left">荣誉与自述</el-divider>
        <div class="text-block"><strong>荣誉：</strong>{{ detail.honor || '-' }}</div>
        <div class="text-block"><strong>自述：</strong>{{ detail.description || '-' }}</div>

        <EnrollmentPdfPreview v-if="detail.file_path" :url="materialUrl(detail.file_path)" title="材料附件" :height="560" />
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { enrollmentAdminApi, resolveEnrollUrl } from '@/api'
import EnrollmentPdfPreview from '@/components/EnrollmentPdfPreview.vue'

const loading = ref(false)
const exporting = ref(false)
const students = ref([])
const stats = ref([])
const detail = ref(null)
const detailVisible = ref(false)
const statusOptions = ['全部', '未审核', '初审通过', '复审通过', '最终通过', '不通过']

const filters = reactive({
  status: '全部',
  name: '',
  school: '',
  id_card: ''
})

const materialUrl = (filePath) => resolveEnrollUrl(`/api/enrollment/uploads/${filePath}`)

const statusTagType = (status) => {
  switch (status) {
    case '初审通过': return 'success'
    case '复审通过': return 'primary'
    case '最终通过': return 'warning'
    case '不通过': return 'danger'
    default: return 'info'
  }
}

const loadStats = async () => {
  stats.value = await enrollmentAdminApi.getStatistics()
}

const loadStudents = async () => {
  loading.value = true
  try {
    students.value = await enrollmentAdminApi.getStudents(filters)
  } finally {
    loading.value = false
  }
}

const resetFilters = async () => {
  filters.status = '全部'
  filters.name = ''
  filters.school = ''
  filters.id_card = ''
  await loadStudents()
}

const openDetail = async (id) => {
  detail.value = await enrollmentAdminApi.getStudentDetail(id)
  detailVisible.value = true
}

const review = async (id, nextStatus) => {
  await enrollmentAdminApi.reviewStudent(id, nextStatus)
  ElMessage.success('审核状态已更新')
  await Promise.all([loadStudents(), loadStats()])
}

const exportFilteredStudents = async () => {
  exporting.value = true
  try {
    const blob = await enrollmentAdminApi.exportStudents(filters)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    const timestamp = new Date().toISOString().replace(/[-:TZ.]/g, '').slice(0, 14)
    link.href = url
    link.download = `自主招生筛选数据_${timestamp}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    ElMessage.success('导出成功')
  } finally {
    exporting.value = false
  }
}

const resetPassword = async (id) => {
  await ElMessageBox.confirm(
    '确定将该学生密码重置为 dhses123456 吗？',
    '重置密码',
    {
      type: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  )
  await enrollmentAdminApi.resetStudentPassword(id)
  ElMessage.success('密码已重置')
}

onMounted(async () => {
  await Promise.all([loadStudents(), loadStats()])
})
</script>

<style scoped>
.enroll-review {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.review-card {
  border-radius: 18px;
  border: 1px solid rgba(191, 219, 254, 0.65);
  box-shadow: 0 15px 36px rgba(30, 64, 175, 0.08);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.header-title h3 {
  color: #0b3a73;
  font-size: 20px;
  margin: 0;
}

.header-title p {
  margin-top: 6px;
  color: #64748b;
}

.stats {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.filter-bar {
  padding: 12px;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(239, 246, 255, 0.85), rgba(240, 249, 255, 0.65));
  margin-bottom: 14px;
}

:deep(.filter-bar .el-form-item) {
  margin-bottom: 0;
}

:deep(.review-table .el-table__header-wrapper th) {
  background: #eff6ff;
  color: #1e3a8a;
}

.action-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.text-block {
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

@media (max-width: 980px) {
  .card-header {
    flex-direction: column;
  }

  .stats {
    justify-content: flex-start;
  }

  .filter-bar {
    padding: 10px;
  }
}
</style>
